// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c2b7ca81","703":"f7aacf2a","787":"d326a635"}[chunkId] + ".chunk.js";
};